/**
 * Central route definitions for the application.
 * Import from '@/lib/routes' — never hardcode route strings.
 */

export const routes = {
  // Landing
  home: '/',
  terms: '/terms',
  privacy: '/privacy',

  // Auth
  signin: '/auth/signin',
  register: '/auth/register',
  signout: '/auth/signout',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password',
  checkEmail: '/auth/check-email',
  onboarding: '/auth/onboarding',
  acceptInvitation: '/auth/accept-invitation',
  authError: '/auth/error',

  // Admin
  admin: '/admin',
  dashboard: '/admin',
  invoices: '/admin/invoices',
  clients: '/admin/clients',
  entities: '/admin/entities',
  templates: '/admin/templates',
  messages: '/admin/messages',
  settings: '/admin/settings',
  dunning: '/admin/dunning',
} as const

export type AppRoute = (typeof routes)[keyof typeof routes]
